export default __webpack_public_path__ + "static/feature-showcase-efa7dfb0cddeb1e0e9d7b8e4ac180f5a.png";